<template>
  <v-dialog v-model="dialog" max-width="850" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn rounded color="info" x-small v-on="on" v-bind="attrs">
        <v-icon size="12" class="mr-1">mdi-pencil</v-icon> Corrigir</v-btn
      >
    </template>
    <manut-indicacao-pcd>      
      <v-btn rounded text @click="dialog = false">Fechar</v-btn>
    </manut-indicacao-pcd>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import ManutIndicacaoPcd from "../components/ManutIndicacaoPcd.vue";
export default {
  props: {
    indParam: Object,
  },
  watch: {
    dialog: function (open) {
      if (open) {
        this.indicacao.id = this.indParam.id;
        this.indicacao.nome = this.indParam.nome;
        this.indicacao.cpf = this.indParam.cpf;
        this.indicacao.dtnascimento = this.indParam.dtnasc;
        this.indicacao.cidade = this.indParam.cidade;
        this.indicacao.endereco = this.indParam.endereco;
        this.indicacao.telefone_pcd = this.indParam.telefone_pcd;
        this.indicacao.telefone_colaborador =
          this.indParam.telefone_colaborador;
        this.indicacao.tiposistema = "WEB";
      }
    },
  },
  components: { ManutIndicacaoPcd },
  computed: mapState("pcd", ["indicacao"]),
  data: () => ({
    dialog: false,
  }),
};
</script>

<style>
</style>